// extracted by mini-css-extract-plugin
module.exports = {"lines":"about-section-module--lines--3vi4E"};